import { useProductCategories } from '@hungryroot/rest-hooks';

export function useSelectedGroceryCategory(props: {
  selectedCategory?: number;
}) {
  const { selectedCategory } = props;

  const { data, isLoading } = useProductCategories();

  return {
    isLoading,
    selectedCategory: data?.results.find(
      (category) => category.id === selectedCategory
    ),
  };
}
